import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconExtenderProps } from './IconExtender.types'
import * as Styled from './styles/IconExtender.style'

import { nonThemeableRules } from '../../ruleSet'

const IconExtender: FC<IconExtenderProps> = ({
  size = nonThemeableRules.defaultSize as number as IconExtenderProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconExtenderProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M8 17.03h8m-5.96-5.67a2.779 2.779 0 0 1 3.92 0m-3.1 1.26c.3-.3.71-.47 1.14-.47s.84.17 1.14.47'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M16.01 19.56c0 1.09-.87 1.97-1.95 1.97h-4.1c-1.08 0-1.95-.88-1.95-1.97V4.49c0-1.09.87-1.97 1.95-1.97h6.06v17.04Z'
            vectorEffect='non-scaling-stroke'
          />
          <circle cx='11.99' cy='14.05' r='.29' vectorEffect='non-scaling-stroke' />
          <circle cx='11.99' cy='14.05' r='.14' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconExtender
